module.exports = __webpack_public_path__ + "static/media/faceOverlay.c1ddb674.svg";